import { all, fork } from 'redux-saga/effects';

import { takeEventAddRequest, takeEventShowRequest, takeEventSingleShowRequest } from './eventSaga';

const eventSagaRequest = function* () {
    yield all([fork(takeEventAddRequest), fork(takeEventShowRequest), fork(takeEventSingleShowRequest)]);
};

export { eventSagaRequest };
